<div class="d-flex justify-content-center align-items-center vh-100 bg-light" style="font-size: 0.88rem;">
  <div class="card shadow border-0 p-4 bg-white" style="width: 100%; max-width: 400px; border-radius: 12px;">
    
    <div class="text-center mb-4 border-bottom pb-3">
      <h2 class="h4 m-0 fw-bold text-dark">Portal del Taller</h2>
      <span class="small text-muted font-monospace" style="letter-spacing: 1px;">SECURITY CONTROL MASTER</span>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      
      <!-- 🚀 NUEVO INPUT FLOATING: CÓDIGO DE COMPAÑÍA / TALLER -->
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="coId" formControlName="coId" placeholder="coId"
               [ngClass]="{'is-invalid': loginForm.get('coId')?.touched && loginForm.get('coId')?.invalid}">
        <label for="coId" class="fw-semibold text-secondary">Código de Compañía / Taller *</label>
        <div class="invalid-feedback">El código de compañía es mandatorio para el aislamiento del taller.</div>
      </div>

      <!-- INPUT ID USUARIO -->
      <div class="form-floating mb-3">
        <input type="text" class="form-control" id="userId" formControlName="userId" placeholder="userId"
               [ngClass]="{'is-invalid': loginForm.get('userId')?.touched && loginForm.get('userId')?.invalid}">
        <label for="userId" class="fw-semibold text-secondary">ID de Usuario JDE *</label>
        <div class="invalid-feedback">El identificador de cuenta es obligatorio.</div>
      </div>

      <!-- INPUT CONTRASEÑA -->
      <div class="form-floating mb-4">
        <input type="password" class="form-control" id="password" formControlName="password" placeholder="Password"
               [ngClass]="{'is-invalid': loginForm.get('password')?.touched && loginForm.get('password')?.invalid}">
        <label for="password" class="fw-semibold text-secondary">Contraseña de Seguridad *</label>
        <div class="invalid-feedback">La contraseña es requerida.</div>
      </div>

      <!-- BOTÓN DE INGRESO -->
      <button type="submit" class="btn btn-primary w-100 py-2 fw-bold shadow-sm" style="border-radius: 8px;">
        🔐 Firmar e Ingresar
      </button>

    </form>
    
    <div class="text-center mt-3 text-muted" style="font-size: 0.75rem;">
      💼 <em>Ecosistema de control integrado a Libro de Direcciones F0101.</em>
    </div>

  </div>
</div>

<router-outlet></router-outlet>